export const GET_SETTINGS = 'BILLINGS/fetch_settings';
export const DUMMY = 'dummy';
